"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigDecimal_1 = require("./BigDecimal");

var DecimalRoundingEnum_1 = require("./DecimalRoundingEnum");

var biZero = BigInt(0);
var biOne = BigInt(1);
var bi32Ones = BigInt('0xffffffff');
var bi32 = BigInt(32);
var bi5 = BigInt(5);

var RealBigDecimal =
/*#__PURE__*/
function (_BigDecimal_1$BigDeci) {
  _inherits(RealBigDecimal, _BigDecimal_1$BigDeci);

  function RealBigDecimal(intVal, scale) {
    var _this;

    _classCallCheck(this, RealBigDecimal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RealBigDecimal).call(this));
    _this.intVal = intVal;
    _this.scale = scale;
    BigDecimal_1.assertIntValue(intVal);

    if (scale > 6 || scale < 0) {
      throw new Error('Invalid scale: ' + scale);
    }

    return _this;
  }

  _createClass(RealBigDecimal, [{
    key: "add",
    value: function add(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (isReal(other)) {
        return add2(this.intVal, this.scale, other.intVal, other.scale);
      }

      return other.add(this);
    }
  }, {
    key: "sub",
    value: function sub(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (isReal(other)) {
        return add2(this.intVal, this.scale, -other.intVal, other.scale);
      }

      return this.add(other.negate());
    }
  }, {
    key: "mul",
    value: function mul(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (!isReal(other)) {
        return other.mul(this);
      }

      var productScale = this.scale + other.scale;
      return multiply(this.intVal, other.intVal, productScale);
    }
  }, {
    key: "div",
    value: function div(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (!isReal(other)) {
        if (other.isNaN()) {
          return BigDecimal_1.BigDecimal.NaN;
        }

        if (other.isInfinity()) {
          return BigDecimal_1.BigDecimal.ZERO;
        }
        /* istanbul ignore next */


        throw new Error('SHN');
      }

      if (this.isZero()) {
        return other.isZero() ? BigDecimal_1.BigDecimal.NaN : this;
      }

      if (other.isZero()) {
        return this.sign() > 0 ? BigDecimal_1.BigDecimal.PInf : BigDecimal_1.BigDecimal.NInf;
      }

      return divide(this.intVal, this.scale, other.intVal, other.scale);
    }
  }, {
    key: "isInfinity",
    value: function isInfinity() {
      return false;
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return false;
    }
  }, {
    key: "isInteger",
    value: function isInteger() {
      if (this.scale <= 0) {
        return true;
      }

      return this.intVal % BigDecimal_1.bigPowerTen(this.scale) === biZero;
    }
  }, {
    key: "sign",
    value: function sign() {
      if (this.intVal === biZero) {
        return 0;
      }

      return this.intVal < biZero ? -1 : 1;
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return this.intVal === biZero;
    }
  }, {
    key: "eq",
    value: function eq(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (!isReal(other)) {
        return other.equals(this);
      }

      return compare(this.intVal, this.scale, other.intVal, other.scale) === 0;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      var iv = this.intVal * BigDecimal_1.bigPowerTen(BigDecimal_1.maxScale - this.scale);
      var m = 7;

      if (iv < biZero) {
        iv = -iv;
        m = 5;
      } // tslint:disable-next-line:no-bitwise


      var hc = Number(iv & bi32Ones ^ iv >> bi32 & bi32Ones); // tslint:disable-next-line:no-bitwise

      return 3 + m * hc | 0;
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(other) {
      if (typeof other === 'number') {
        other = BigDecimal_1.BigDecimal.valueOf(other);
      }

      if (!isReal(other)) {
        return other.isNaN() ? false : !other.greaterThan(this);
      }

      return compare(this.intVal, this.scale, other.intVal, other.scale) > 0;
    }
  }, {
    key: "negate",
    value: function negate() {
      return new RealBigDecimal(-this.intVal, this.scale);
    }
  }, {
    key: "downscale",
    value: function downscale() {
      if (this.scale === 0) {
        return this;
      }

      var power = BigDecimal_1.bigPowerTen(this.scale);
      var rem = this.intVal % power;
      var s = this.findScale(rem, 0, this.scale);
      return new RealBigDecimal(this.intVal / BigDecimal_1.bigPowerTen(s), this.scale - s);
    }
  }, {
    key: "findScale",
    value: function findScale(iv, mins, maxs) {
      if (mins === maxs) {
        return mins;
      } // tslint:disable-next-line:no-bitwise


      var mid = mins + maxs + 1 >> 1;

      if (iv % BigDecimal_1.bigPowerTen(mid) === biZero) {
        return this.findScale(iv, mid, maxs);
      }

      return this.findScale(iv, mins, mid - 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "round",
    value: function round(decimalPlaces, rounding) {
      rounding = rounding === undefined ? DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_HALF_CEIL : rounding;

      if (decimalPlaces < 0 || decimalPlaces > BigDecimal_1.maxScale) {
        throw new Error('Requested decimal places is outside limit: ' + decimalPlaces);
      }

      if (this.isZero()) {
        return BigDecimal_1.BigDecimal.ZERO; //Scale is 0
      }

      if (this.scale <= decimalPlaces) {
        return this;
      }

      var sign = this.sign();
      var scaleDiff = this.scale - decimalPlaces; // >= 1

      var divisor = BigDecimal_1.bigPowerTen(scaleDiff);
      var half = bi5 * BigDecimal_1.bigPowerTen(scaleDiff - 1);
      var iv = this.intVal / divisor;
      var rem = this.intVal % divisor;

      if (rem !== biZero) {
        if (rem < biZero) {
          rem = -rem;
        }

        switch (rounding) {
          case DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_HALF_CEIL:
            if (rem > half) {
              iv += sign < 0 ? -biOne : biOne;
            } else if (rem === half) {
              iv += sign < 0 ? biZero : biOne;
            }

            break;

          case DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_DOWN:
            //Do nothing
            break;

          case DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_UP:
            iv += sign < 0 ? -biOne : biOne;
            break;

          case DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_FLOOR:
            iv += sign < 0 ? -biOne : biZero;
            break;

          case DecimalRoundingEnum_1.DecimalRoundingEnum.ROUND_CEIL:
            iv += sign < 0 ? biZero : biOne;
            break;

          default:
            throw new Error('Rounding not supported: ' + rounding);
        }
      }

      return new RealBigDecimal(iv, this.scale - scaleDiff);
    }
  }, {
    key: "toFixed",
    value: function toFixed(decimalPlaces, rounding) {
      var r = this.round(decimalPlaces, rounding);
      var str = r.toString(true);

      if (this.scale < decimalPlaces) {
        if (this.scale === 0) {
          str = str + '.';
        }

        str = str + '0'.repeat(decimalPlaces - this.scale);
      }

      return str;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "floor",
    value: function floor() {
      if (this.isZero()) {
        return BigDecimal_1.BigDecimal.ZERO; //Scale is 0
      }

      if (this.scale === 0) {
        return this;
      }

      var divisor = BigDecimal_1.bigPowerTen(this.scale);
      var iv = this.intVal / divisor;
      var rem = this.intVal % divisor;

      if (this.intVal < biZero && rem !== biZero) {
        iv -= biOne;
      }

      return new RealBigDecimal(iv, 0);
    }
  }, {
    key: "abs",
    value: function abs() {
      return this.sign() < 0 ? this.negate() : this;
    }
  }, {
    key: "toString",
    value: function toString(skipDownscale) {
      var sign = '';
      var intVal = this.intVal;

      if (intVal < biZero) {
        sign = '-';
        intVal = -intVal;
      }

      var s = intVal.toString();

      if (this.scale === 0) {
        return sign + s;
      }

      if (this.scale < 0) {
        /* istanbul ignore next */
        throw new Error('SHN'); //return s + '0'.repeat(- this.scale);
      }

      if (s.length <= this.scale) {
        s = '0'.repeat(this.scale - s.length + 1) + s;
      }

      var end = s.length - this.scale;
      s = s.substring(0, end) + '.' + s.substring(end);

      if (!skipDownscale) {
        while (s.endsWith('0')) {
          s = s.substring(0, s.length - 1);
        }

        if (s.endsWith('.')) {
          s = s.substring(0, s.length - 1);
        }
      }

      return sign + s;
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      if (this.scale === 0) {
        return Number(this.intVal);
      }

      var power = BigDecimal_1.bigPowerTen(this.scale);
      var rem = this.intVal % power;
      var ret = Number(this.intVal / power);
      ret += Number(rem) / Number(power);
      return ret;
    }
  }, {
    key: "min",
    value: function min(other) {
      if (!isReal(other)) {
        return other.min(this);
      }

      return this.greaterThan(other) ? other : this;
    }
  }, {
    key: "max",
    value: function max(other) {
      if (!isReal(other)) {
        return other.max(this);
      }

      return this.lessThan(other) ? other : this;
    }
  }]);

  return RealBigDecimal;
}(BigDecimal_1.BigDecimal);

exports.RealBigDecimal = RealBigDecimal;

function isReal(bd) {
  return !bd.isInfinity() && !bd.isNaN();
}

function add2(fst, scale1, snd, scale2) {
  var rscale = scale1;
  var sdiff = rscale - scale2;

  if (sdiff !== 0) {
    if (sdiff < 0) {
      var raise = -sdiff;
      rscale = scale2;
      fst = BigDecimal_1.bigMultiplyPowerTen(fst, raise);
    } else {
      var _raise = sdiff;
      snd = BigDecimal_1.bigMultiplyPowerTen(snd, _raise);
    }
  }

  var sum = fst + snd;
  return new RealBigDecimal(sum, rscale);
}

function compare(fst, scale1, snd, scale2) {
  var sdiff = scale1 - scale2;

  if (sdiff !== 0) {
    if (sdiff < 0) {
      fst = BigDecimal_1.bigMultiplyPowerTen(fst, -sdiff);
    } else {
      snd = BigDecimal_1.bigMultiplyPowerTen(snd, sdiff);
    }
  }

  if (fst === snd) {
    return 0;
  }

  return fst < snd ? -1 : 1;
}

function multiply(x, y, scale) {
  var intVal = x * y;

  if (scale <= BigDecimal_1.maxScale) {
    return new RealBigDecimal(intVal, scale);
  }

  intVal = intVal / BigDecimal_1.bigPowerTen(scale - BigDecimal_1.maxScale);
  return new RealBigDecimal(intVal, BigDecimal_1.maxScale);
}

function divide(dividend, dividendScale, divisor, divisorScale) {
  var newScale = BigDecimal_1.maxScale + divisorScale;
  var raise = newScale - dividendScale;
  var scaledDividend = BigDecimal_1.bigMultiplyPowerTen(dividend, raise);
  var mr = scaledDividend % divisor;
  var mq = scaledDividend / divisor;
  var isRemainderZero = mr === biZero; //qsign = (bdividend.signum != bdivisor.signum) ? -1 : 1;

  var ret = new RealBigDecimal(mq, BigDecimal_1.maxScale);
  return isRemainderZero ? ret.downscale() : ret; // if (!isRemainderZero) {
  //     // if (needIncrement(mdivisor, roundingMode, qsign, mq, mr)) {
  //     // mq.add(MutableBigInteger.ONE);
  //     //}
} // function needIncrement(divisor: bigint, mq: bigint, mr: bigint) {
//    const cmpFracHalf = mr.compareHalf(mdivisor);
//     return commonNeedIncrement(roundingMode, qsign, cmpFracHalf, mq.isOdd());
// }